import { Container, Header, Segment, Grid, Button } from "semantic-ui-react";

export const Downloads = (props) => {
  return (
    <Segment id="downloads" vertical padded="very">
      <Container textAlign="center">
        <Header as="h1" textAlign="center">
          Downloads
        </Header>
        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={4}>
              <p>Baseline Code</p>
            </Grid.Column>
            <Grid.Column width={12}>
              <Button
                fluid
                color="black"
                content="Github Repository"
                size="huge"
                as="a"
                href="https://github.com/BCV-Uniandes/PNG"
                target="_blank"
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={4}>
              <p>Pre-trained model</p>
            </Grid.Column>
            <Grid.Column width={12}>
              <Button
                fluid
                color="black"
                content="Pretrained model"
                size="huge"
                as="a"
                href="https://lambda004.uniandes.edu.co/panoptic-narrative-grounding/pretrained-models/model_final.pth"
                download="model_final.pth"
                target="_blank"
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={4}>
              <p>Ground-Truth Annotations</p>
            </Grid.Column>
            <Grid.Column width={6}>
              <Button
                fluid
                color="black"
                content="Train"
                size="huge"
                as="a"
                href="https://lambda004.uniandes.edu.co/panoptic-narrative-grounding/annotations/png_coco_train2017.json"
                download="png_coco_train2017.json"
                target="_blank"
              />
            </Grid.Column>
            <Grid.Column width={6}>
              <Button
                fluid
                color="black"
                content="Validation"
                size="huge"
                as="a"
                href="https://lambda004.uniandes.edu.co/panoptic-narrative-grounding/annotations/png_coco_val2017.json"
                download="png_coco_val2017.json"
                target="_blank"
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={4}>
              <p>Pre-computed features</p>
            </Grid.Column>
            {/* <Grid.Column width={6}>
              <Button fluid color="black" content="Train" size="huge" />
            </Grid.Column> */}
            <Grid.Column width={12}>
              <Button
                fluid
                color="black"
                content="Validation"
                size="huge"
                as="a"
                href="https://lambda004.uniandes.edu.co/panoptic-narrative-grounding/features/val2017.zip"
                download="val2017.tar.gz"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  );
};
